import { BaseScenarioData } from './BaseScenarioData.ts';
import { ScenarioSettingEnum } from '@colonist/game-base-types';
export class ScenarioDataNone extends BaseScenarioData {
    constructor(...args){
        super(...args), this.scenarioSetting = ScenarioSettingEnum.None, this.defaultVPsToWin = 10;
    }
}
export class ScenarioDataHeadingForNewShores extends BaseScenarioData {
    constructor(...args){
        super(...args), this.scenarioSetting = ScenarioSettingEnum.SS1HeadingForNewShores, this.defaultVPsToWin = 14;
    }
}
export class ScenarioDataFourIslands extends BaseScenarioData {
    constructor(...args){
        super(...args), this.scenarioSetting = ScenarioSettingEnum.SS2TheFourIslands, this.defaultVPsToWin = 13;
    }
}
export class ScenarioDataFogIsland extends BaseScenarioData {
    constructor(...args){
        super(...args), this.scenarioSetting = ScenarioSettingEnum.SS3TheFogIslands, this.defaultVPsToWin = 12;
    }
}
export class ScenarioDataThroughTheDesert extends BaseScenarioData {
    constructor(...args){
        super(...args), this.scenarioSetting = ScenarioSettingEnum.SS4ThroughTheDesert, this.defaultVPsToWin = 14;
    }
}
